import * as types from '../actionTypes/annualReturn'

let defaultState = {
  lobbyistAnnualReturns: [],
  changesRequired: {},
  currentAnnualReturn: {}
}

const annualReturnReducer = (state = defaultState, action) => {
  if (action.type === types.GET_ANNUAL_RETURN) {
    // if view model not loaded then create empty object so we can bind form in components to that without undefined issues
    if (!action.annualReturn) {
      action.annualReturn = {}
    }
    return {
      ...state,
      currentAnnualReturn: action.annualReturn
    }
  }
  else if (action.type === types.GET_ANNUAL_RETURN_FOR_LOBBYIST) {
    return {
      ...state,
      lobbyistAnnualReturns: action.lobbyistAnnualReturns
    }
  }
  else if (action.type === types.CLEAR_ANNUAL_RETURNS_FOR_LOBBYIST) {
    return {
      ...state,
      lobbyistAnnualReturns: []
    }
  }
  else if (action.type === types.GET_CHANGES_REQUIRED) {
    // if view model not loaded then create empty object so we can bind form in components to that without undefined issues
    if (!action.changesRequired) {
      action.changesRequired = {}
    }
    return {
      ...state,
      changesRequired: action.changesRequired
    }
  }
  else {
    return {
      ...state
    }
  }
}

export default annualReturnReducer


// WEBPACK FOOTER //
// ./src/reducers/annualReturn.js